// @flow
import React from 'react';
import type { Node } from 'react';

import styles from './contentFiltersContainer.css';


type ContentFiltersContainerPropTypes = {
  children?: Node,
  className?: string,
  size?: string,
  hasContent?: boolean
};

const ContentFiltersContainer = ({
  children,
  className = '',
  size = 'medium',
  hasContent = true,
}: ContentFiltersContainerPropTypes) => (
  <div
    className={
      `
        ${styles.contentFiltersContainer}
        ${styles[size]}
        ${className}
        ${!hasContent ? styles.cardRowHasNoContent : ''}
      `
    }
  >
    { children }
  </div>
);

export default ContentFiltersContainer;



// WEBPACK FOOTER //
// ./src/scripts/components/ContentFiltersContainer/index.jsx